'use client';
import React, { useEffect, useState } from 'react';
import { IoIosSearch } from 'react-icons/io';
import { white } from '../common/styleguide';
import { apiURL } from '../common/urls';
import PFLink from './PFLink';

export function SearchInput() {
  const [liveQuery, setLiveQuery] = useState('');
  const [sugesstions, setSugesstions] = useState<[] | null>(null);

  useEffect(() => {
    if (!liveQuery) return;
    const controller = new AbortController();
    const { signal } = controller;

    const debounce = setTimeout(() => {
      fetch(`${apiURL}/tag-suggestions?term=${liveQuery}`, {
        signal,
      })
        .then((res) => res.json())
        .then((json) => {
          setSugesstions(json);
        })
        .catch((err) => {
          setSugesstions(null);
        });
    }, 200);
    return () => {
      clearTimeout(debounce);
      controller.abort();
    };
  }, [liveQuery]);

  return (
    <>
      <div className="flex m-5">
        <form
          role="search"
          method="get"
          action="/suche/"
          className="flex flex-1"
        >
          <input
            onChange={(event) => setLiveQuery(event.target.value)}
            value={liveQuery}
            autoFocus
            itemProp="query-input"
            type="text"
            placeholder="Suchbegriff"
            name="q"
            className="focus:outline-none caret-primaryColor rounded-l-xl text-lg font-medium text-darkGrey flex-1 h-11 border-solid border-2 border-r-[1px] border-primaryColor p-2 z-[1] focus:ring-2 focus:ring-selectionColor focus:border-selectionColor placeholder:text-placeholderTextColor"
          />
          <button
            type="submit"
            className="rounded-r-xl cursor-pointer h-11 w-11 border-none bg-tintColor flex justify-center items-center"
          >
            <IoIosSearch size={24} color={white} />
          </button>
        </form>
      </div>
      {sugesstions && sugesstions.length > 0 && (
        <>
          <div className="text-center text-darkGrey dark:text-white font-bold">
            Meinst du
          </div>
          <ul>
            {sugesstions.map((item) => (
              <li key={item.slug} className="text-center m-5">
                <PFLink href={`/suche/?q=${item.name}`}>{item.name}</PFLink>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
}
